import {
  type OutgoingInvoice,
  useProformaInvoiceQuery,
} from "@src/__generated__/graphql";
import { Spinner } from "@src/components/ui-kit";
import { useStore } from "@src/utils/hooks";
import { FormMode } from "@src/utils/types";
import { observer } from "mobx-react-lite";
import { type FC, useEffect, useState } from "react";
import { Container } from "../components";
import { InvoiceStore, InvoiceStoreContext, InvoiceTypeEnum } from "../store";

type DuplicateOutgoingInvoiceProps = {
  id: OutgoingInvoice["id"];
};

const INVOICE_TYPE = InvoiceTypeEnum.Proforma;

export const DuplicateProformaInvoice: FC<DuplicateOutgoingInvoiceProps> =
  observer(function DuplicateProformaInvoice({ id }) {
    const appStore = useStore();
    const [store] = useState(
      () => new InvoiceStore(appStore, true, INVOICE_TYPE, FormMode.DUPLICATE),
    );

    const { data, loading } = useProformaInvoiceQuery({ variables: { id } });

    useEffect(() => {
      if (!data?.outgoingProformaInvoice) return;
      store.type = INVOICE_TYPE;
      store.duplicate(data.outgoingProformaInvoice);
    }, [data?.outgoingProformaInvoice]);

    if (loading) {
      return <Spinner absolute />;
    }

    return (
      <InvoiceStoreContext.Provider value={store}>
        <Container />
      </InvoiceStoreContext.Provider>
    );
  });
